import { Play, BookOpen, Download, Award, Users } from "lucide-react";

export default function UspBar() {
  const items = [
    { icon: <Play size={16} />, text: "20+ lessen" },
    { icon: <BookOpen size={16} />, text: "4 modules" },
    { icon: <Download size={16} />, text: "Praktische werkboeken" },
    { icon: <Award size={16} />, text: "Certificaat na afronding" },
    { icon: <Users size={16} />, text: "Geschikt voor elk niveau" },
  ];
  return (
    <div data-testid="usp-bar" className="bg-[#111111] border-y border-white/5 py-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-6 lg:gap-10">
          {items.map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-2 text-zinc-300 text-sm font-medium">
              <span className="text-[#C9A84C]">{icon}</span> {text}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
